export const FALLBACK_IMAGE = "/assets/layout/images/widgets/sin_img.jpg";
export const MOBILE_BREAKPOINT = 1150;
